function repeat(source, count) {
  return new Array(count + 1).join(source);
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  repeat
};
//# sourceMappingURL=repeat.js.map
